import type {
  BaseQueryFn,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { matchedData, oddsResponse } from "./odds";

export const oddsData = createApi({
  reducerPath: "oddsData",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_ODDS_API,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("admin-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }) as BaseQueryFn<
    string | { url: string; method: string; body?: any },
    unknown,
    FetchBaseQueryError
  >,
  endpoints: (build) => ({
    activeMatch: build.mutation<matchedData, void>({
      query: () => ({
        url: "/betfair_api/active_match/v4/4",
        method: "GET",
      }),
    }),
    oddsData: build.query<oddsResponse, string | undefined>({
      query: (agrs) => ({
        // url: `/betfair_api/fancy/${agrs}`,
        url: `betfair_api/fancy/bg/${agrs}`,
        method: "GET",
      }),
    }),
    casinoOdds: build.query<oddsResponse, string | undefined>({
      query: (agrs) => ({
        url: `${import.meta.env.VITE_CASINO_API.replace(/\/+$/, "")}/betfair_api/casino/data/meta-${agrs}`,
        method: "GET",
      }),
    }),
    myIp: build.query<myIpRes, void>({
      query: (agrs) => ({
        url: `/betfair_api/my-ip`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useActiveMatchMutation,
  useOddsDataQuery,
  useCasinoOddsQuery,
  useMyIpQuery,
} = oddsData;
